import type { Vault } from '@/types/vault'

export function isVaultInNetworks(vault: Vault, networks: string[]): boolean {
  if (networks.length === 0) return true
  return networks.includes(vault.network.name)
}
